export const StoryCircle = ({ person, selected, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(person.id)}
    data-testid={`story-circle-${person.id}`}
    aria-pressed={selected}
    aria-label={`${person.isMe ? "Your story" : `${person.name}'s story`}`}
    className="flex w-[62px] shrink-0 flex-col items-center gap-1.5 focus-visible:outline-none"
  >
    <span className={`story-ring ${selected ? "is-selected" : ""}`}>
      <img src={person.avatar} alt="" className="h-full w-full rounded-full object-cover" />
    </span>
    <span className={`text-[11px] leading-none ${selected ? "font-bold text-[#08090D]" : "font-medium text-[#3c4052]"}`}>
      {person.isMe ? "You" : person.name}
    </span>
  </button>
);
